<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('event_manage.e-certificatelist') }}</h4>
      </template>
       <template v-slot:body>
          <b-row>
              <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.year')"
                    label-for="registration_year"
                    >
                    <b-form-select
                    plain
                    v-model="search.year"
                    :options="yearList"
                    id="year"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col xs="12" sm="12" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="org_name"
              >
                <template v-slot:label>
                  {{ $t('event_manage.org_name')}}
                </template>
                <b-form-input
                    id="org_name"
                    v-model="search.org_name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="event_name"
              >
                <template v-slot:label>
                  {{ $t('event_manage.event_name')}}
                </template>
                <b-form-input
                    id="event_name"
                    v-model="search.event_name"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      :label="$t('event_manage.start_date')"
                      label-for="start_date"
                      >
                      <b-form-input
                      class="date-picker"
                      v-model="search.start_date"
                      id="start_date"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-input>
                  </b-form-group>
              </b-col>
              <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      :label="$t('event_manage.end_date')"
                      label-for="end_date"
                      >
                      <b-form-input
                      class="date-picker"
                      v-model="search.end_date"
                      id="end_date"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-input>
                  </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
            </b-col>
          </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(registration_id)="data">
                      {{ $n(data.item.registration_id, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(registration_date)="data">
                      {{data.item.registration_date|dateFormat}}
                    </template>
                     <template v-slot:cell(detail)="data">
                          <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                    </template>
                    <template v-slot:cell(status)="data">
                      {{ getStatus(data.item.status) }}
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="lg" :title="$t('event_manage.e-certificate')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId" :item="item"/>
    </b-modal>
  </b-container>
</template>
<script>

import { mapGetters } from 'vuex'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { stallParticipantCertificateData } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import DetailModal from './DetailModal'
import flatpickr from 'flatpickr'
import custom from '@/store/custom'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal
  },
  data () {
    return {
      search: {
        year: new Date().getFullYear(),
        org_name: '',
        event_name: '',
        start_date: '',
        end_date: ''
      },
      rows: [],
      editItemId: 0,
      item: '',
      data: [],
      rejectItemId: '',
      isRetailer: false,
      ItemShow: false,
      CityCorpItemShow: false,
      PauroshobaItemShow: false,
      UnionItemShow: false,
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: []
    }
  },
  computed: {
    yearList: function () {
      const year = new Date().getFullYear() - 10
      const years = []
      for (let i = year; i <= new Date().getFullYear(); i++) {
        if (this.$i18n.locale === 'bn') {
          years.push({ text: this.$n(i, { useGrouping: false }), value: i })
        } else {
          years.push({ text: i, value: i })
        }
      }
      return years.reverse()
    },
     i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    monthList: function () {
      return this.$store.state.commonObj.monthList
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    registrationTypeList: function () {
        return this.$store.state.ProductionService.commonObj.registrationTypeList
    },
    disabilityTypeList () {
      return this.$store.state.AwarenessEventService.commonObj.disabilityTypeList
    },
    getAreaTypeList: function () {
      const objectData = custom.wardTypeList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('event_manage.event_name'), class: 'text-center' },
          { label: this.$t('event_manage.org_name'), class: 'text-center' },
          { label: this.$t('retailerManagement.details'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'event_info_bn' },
          { key: 'org_name_bn' },
          { key: 'detail' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'event_info' },
          { key: 'org_name' },
          { key: 'detail' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'search.division_id': function (newVal, oldVal) {
      if (newVal) {
        this.search.district_id = 0
        this.districtList = this.getDistrictList(newVal)
      } else {
        this.districtList = []
      }
    },
    'search.district_id': function (newVal, oldVal) {
      if (newVal) {
        this.city_corporation_id = 0
        this.upazilla_id = 0
        this.cityCorporationList = this.getCityCorporationList(newVal)
        this.upazilaList = this.getUpazilaList(newVal)
      } else {
         this.cityCorporationList = []
         this.upazilaList = []
      }
    },
    'search.upazila_id': function (newVal, oldVal) {
      if (newVal) {
        this.unionId = 0
        this.pauroshoba_id = 0
        this.unionList = this.getUnionList(newVal)
        this.pauroshobaList = this.getPauroshobaList(newVal)
      } else {
        this.unionList = []
        this.pauroshobaList = []
      }
    },
    'search.city_corporation_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.paurasabha_id && !this.search.union_id) {
        this.wardList = this.getWardListByCityCorportaion(newVal)
      }
    },
    'search.paurasabha_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.city_corporation_id && !this.search.union_id) {
        this.wardList = this.getWardListByPauroshoba(newVal)
      }
    },
    'search.union_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.paurasabha_id && !this.search.city_corporation_id) {
        this.wardList = this.getWardListByUnion(newVal)
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    flatpickr('.date-picker', {})
  },
  methods: {
    fiscalYearDateRange (id) {
        const Date = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
        this.search.fis_start_date = Date.start_date
        this.search.fis_end_date = Date.end_date
    },
    details (item) {
      this.editItemId = item.id
      this.item = item
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const userId = this.$store.state.Auth.authUser.id
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage, user: userId })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(awarenessEventServiceBaseUrl, stallParticipantCertificateData, params).then(response => {
          if (response.success) {
            this.data = response.data
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getCustomDataList (data) {
      const listData = data.map(item => {
        const disabledTypeList = this.$store.state.AwarenessEventService.commonObj.disabilityTypeList.find(type => type.value === item.disable_type_id)
          const disabledTypeData = {}
          if (typeof disabledTypeList !== 'undefined') {
              disabledTypeData.disabled_name_en = disabledTypeList.text_en
              disabledTypeData.disabled_name_bn = disabledTypeList.text_bn
          } else {
              disabledTypeData.disabled_name_en = ''
              disabledTypeData.disabled_name_bn = ''
          }
          const divisionList = this.$store.state.commonObj.divisionList.find(division => division.value === item.division_id)
          const divisonData = {}
           if (typeof divisionList !== 'undefined') {
              divisonData.division_name = divisionList.text_en
              divisonData.division_name_bn = divisionList.text_bn
          } else {
              divisonData.division_name = ''
              divisonData.division_name_bn = ''
          }
          const districtList = this.$store.state.commonObj.districtList.find(district => district.value === item.district_id)
          const districtData = {}
          if (typeof districtList !== 'undefined') {
            districtData.district_name = districtList.text_en
            districtData.district_name_bn = districtList.text_bn
          } else {
            districtData.district_name = ''
            districtData.district_name_bn = ''
          }

          return Object.assign({}, item, disabledTypeData, divisonData, districtData)
      })
      return listData
    },
    getStatus (status) {
      if (status === 1) {
        return this.$t('event_manage.pending')
      } else if (status === 2) {
        return this.$t('event_manage.forward')
      } else if (status === 3) {
        return this.$t('event_manage.approved')
      } else if (status === 4) {
        return this.$t('event_manage.reject')
      }
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
        this.CityCorpItemShow = true
        this.PauroshobaItemShow = false
        this.UnionItemShow = false
      } else if (typeId === 2) {
        this.CityCorpItemShow = false
        this.PauroshobaItemShow = true
        this.UnionItemShow = false
      } else if (typeId === 3) {
        this.CityCorpItemShow = false
        this.PauroshobaItemShow = false
        this.UnionItemShow = true
      }
    },
    getDistrictList (divisionId = null) {
      const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

      if (divisionId) {
        return districtList.filter(district => district.division_id === divisionId)
      }

      return districtList
    },
    getUpazilaList (districtId = null) {
      const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

      if (districtId) {
        return upazilaList.filter(upazila => upazila.district_id === districtId)
      }

      return upazilaList
    },
    getUnionList (upazilaId = null) {
      const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
      if (upazilaId) {
        return unionList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionList
    },
    getCityCorporationList (districtId) {
      const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getPauroshobaList (upazillaId = null) {
      const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
      if (upazillaId) {
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === parseInt(cityCorpId) && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByUnion (unionId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getDisabilityTypeNameList (disabilityTypes) {
      const arr = []
      disabilityTypes.forEach(item => {
        const disabilityType = this.disabilityTypeList.find(obj => obj.value === item)
        const disabilityTypeName = this.currentLocale === 'en' ? disabilityType.text_en : disabilityType.text_bn
        arr.push(disabilityTypeName)
      })
      return arr.toString()
    }
  }
}
</script>
<style lang="css">
    td {
      background-color: white;
    }
</style>
